import Typography from '@mui/material/Typography';

export const ReportHeading = () => {
  return (
    <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
      NeTEx validation report
    </Typography>
  );
};
